import * as React from 'react';
import { PrimaryButton } from '@bb-ui/react-library/dist/components/Button';
import { useTranslation } from 'react-i18next';
import { Add } from '@bb-ui/icons/dist/small';
import CreateReleaseStageDialog from 'dialogs/CreateReleaseStageDialog';
import { makeStyles } from '@bb-ui/react-library';

const useStyles = makeStyles(() => ({
  button: {
    minWidth: 'auto',
    height: '1.5rem',
    padding: '0.2rem 0.5rem',
    fontSize: '0.75rem',
  },
}));

export interface AddReleaseStageButtonProps {
  onReload: () => void;
}

export const AddReleaseStageButton: React.FunctionComponent<AddReleaseStageButtonProps> = ({
  onReload,
}) => {
  const { t } = useTranslation();
  const [createButtonDialogOpen, setCreateButtonDialogOpen] = React.useState(false);
  const classes = useStyles();

  return (
    <>
      <PrimaryButton
        startIcon={<Add />}
        data-testid="header-add-button-release-state"
        onClick={() => setCreateButtonDialogOpen(true)}
        className={classes.button}
      >
        {t('releaseStages.addReleaseStageButton')}
      </PrimaryButton>
      <CreateReleaseStageDialog
        id="create-release-stage-dialog"
        onClose={() => setCreateButtonDialogOpen(false)}
        onSuccess={onReload}
        open={createButtonDialogOpen}
      />
    </>
  );
};
